

const initialState = {
  editingStation: null,
};

const editBluedotStation = (state = initialState, action) => {
  switch (action.type) {
    case "EDIT_INDIVIDUAL_STATION":
      return {
        ...state,
        editingStation: action.station,
      };

    default:
      return state;
  }
};
export default editBluedotStation